module.exports = __webpack_public_path__ + "images/mobile/img-empty-project-56cc1879880fb63d2e32655953104aee.png";